import React, { useState } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'shadcn/components/ui/Dialog';

/**
 * Read-only image thumbnail that opens a dialog preview.
 *
 * @param {Object} props
 * @param {string|null|undefined} props.src - Full CDN URL
 * @param {string} props.alt
 * @param {string} props.label - Accessible button label
 */
function PartnerCatalogImageCell({ alt, label, src }) {
    const [open, setOpen] = useState(false);

    if (!src) {
        return null;
    }

    return (
        <>
            <button
                type="button"
                className="rounded border border-border p-0.5 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                aria-label={label}
                onClick={() => setOpen(true)}
            >
                <img src={src} alt={alt} className="h-[72px] w-[72px] object-cover" />
            </button>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="sm:max-w-2xl">
                    <DialogHeader>
                        <DialogTitle>{label}</DialogTitle>
                    </DialogHeader>
                    <div className="flex justify-center">
                        <img src={src} alt={alt} className="max-h-[70vh] w-auto max-w-full object-contain" />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}

export { PartnerCatalogImageCell };
